import { useSessionStorage } from '@betterment/js-runtime';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { BillingPlanFlowValues } from '../data';

export function useBillingPlanStorage(initialValues?: BillingPlanFlowValues): {
  values: BillingPlanFlowValues | null;
  saveValues: (newValues: BillingPlanFlowValues) => void;
  clearValues: () => void;
} {
  const id = useRequiredParam('id');
  return useSessionStorage<BillingPlanFlowValues>(`${id}-billing-plan-flow`, initialValues);
}
